var uuidv4 = require('./uuidv4');

function isLocalStorageAvailable(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

var __Storage = function(parent) {
    this.id = Cookies.get('form_data_id') ? Cookies.get('form_data_id') : uuidv4();
    Cookies.set('form_data_id', this.id);
    this.type = isLocalStorageAvailable() ? 'local' : 'cookie';
    this.engine = this.type == 'local' ? localStorage : Cookies;
    this.suffix = this.type == 'local' ? 'Item' : '';
};

__Storage.prototype = {
    constructor: __Storage,
    engine: undefined,
    type: undefined,
    suffix: undefined,
    id: undefined,
    getItem: function(name, keep) {
        this.verify();
        var data = this.getData();
        var value = data[name];
        if (!keep) {
            this.removeItem(name);
        }
        return value;
    },
    setItem: function(name, value) {
        this.verify();
        var data = this.getData();
        data[name] = value;
        this.setData(data);
    },
    hasItem: function(name) {
        this.verify();
        var data = this.getData();
        return typeof data[name] !== 'undefined';
    },
    removeItem: function(name) {
        this.verify();
        var data = this.getData();
        delete data[name];
        this.setData(data);
    },
    getData: function() {
        this.verify();
        return JSON.parse(this.engine['get' + this.suffix]('d-' + this.id));
    },
    setData: function(data) {
        this.verify();
        this.engine['set' + this.suffix]('d-' + this.id, JSON.stringify(data));
    },
    verify: function() {
        var self = this;
        if (!this.engine['get' + this.suffix]('d-' + this.id)) {
            this.engine['set' + this.suffix]('d-' + this.id, JSON.stringify({}));
        }
    },
    wipeData: function() {
        if (this.engine.clear) {
            this.engine.clear();
            Cookies.set('form_data_id', uuidv4());
        }
    }
};

window.Storage = new __Storage();
module.exports = window.Storage;